import { Photo } from './Photo';
import { registerSchema } from './transform';

/**
 * Consolidated view of multiple photo lists for Discover screen display.
 * Each list contains a maximum of 6 photos with no pagination.
 */
export class DiscoverPhotos {
  LatestPhotos: Photo[] = [];
  LatestPhotosFollowings: Photo[] = [];
  LatestPhotosPrivate: Photo[] = [];
  LatestPhotosLiked: Photo[] = [];
  IsMyTypeFiltered?: boolean | null;
}

registerSchema(DiscoverPhotos, {
  LatestPhotos: [Photo],
  LatestPhotosFollowings: [Photo],
  LatestPhotosPrivate: [Photo],
  LatestPhotosLiked: [Photo],
});

